import { useState, useEffect } from 'react';
import { AuthenticationState } from 'src/components/auth/FederatedAuth';
import {
  IsSourceReviewerInput,
  useIsSourceReviewerQuery,
} from 'src/generated/graphql';

const CYPRESS_TEST_USER_ALIAS = 'svc-hydra-cypress';

export const useSourceReviewPermissions = (
  stage: string,
  userId: string | null,
  authState: AuthenticationState
) => {
  const [hasSourceReviewPermissions, setHasSourceReviewPermissions] =
    useState(false);

  //Checks if user alias is valid
  const userAliasRegex = /^[a-z]{3,16}$/;
  const isValidUserAlias =
    userId &&
    (userId === CYPRESS_TEST_USER_ALIAS || userAliasRegex.test(userId));

  const params: IsSourceReviewerInput = {
    userAlias: userId,
  };

  /* Gql Hooks*/
  //Gets authorized string groups for user
  const {
    data: isSourceReviewerData,
    loading: isSourceReviewerLoading,
    error: isSourceReviewerError,
  } = useIsSourceReviewerQuery({
    variables: { params },
    errorPolicy: 'all',
    skip: !isValidUserAlias,
  });

  // Checks if user is a source reviewer or not
  // This is to display/hide Review Content tab
  useEffect(() => {
    const hasPermissions =
      authState === AuthenticationState.LOGGED_IN &&
      !isSourceReviewerLoading &&
      !isSourceReviewerError &&
      !!isSourceReviewerData?.isSourceReviewer?.isReviewer;

    setHasSourceReviewPermissions(hasPermissions);
  }, [
    authState,
    isSourceReviewerLoading,
    isSourceReviewerError,
    isSourceReviewerData,
  ]);

  return { hasSourceReviewPermissions };
};
